import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectCurrentBreadCrumbs } from '../../selectors/breadCrumbs';
import { IApplicationState } from '../../types/redux';
import { selectCurrentPageMeta } from '../../selectors/pagesMeta';
import { selectTags } from '../../selectors/tags/selectTags';

/**
 * Следит за текущими хлебными крошками
 */
export const useCurrentBreadCrumbs = () => {
  const { search, pathname } = useLocation();
  const searchParams = new URLSearchParams(search);
  const qsWithTag = (searchParams.get('with-tag') || '').toLowerCase();
  const tags = useSelector(selectTags);
  const { pathname: currentPageMetaPathname } = useSelector((state: IApplicationState) =>
    selectCurrentPageMeta(state, pathname),
  );
  const currentBreadCrumbs = useSelector((state: IApplicationState) =>
    selectCurrentBreadCrumbs(state, {
      pathname: currentPageMetaPathname,
      withTag: tags.find(tag => tag.name === qsWithTag)?.name,
    }),
  );
  const [breadCrumbs, setBreadCrumbs] = useState(currentBreadCrumbs);

  useEffect(() => {
    if (JSON.stringify(currentBreadCrumbs) === JSON.stringify(breadCrumbs)) {
      return;
    }

    setBreadCrumbs(currentBreadCrumbs);
  }, [breadCrumbs, currentBreadCrumbs]);

  return breadCrumbs;
};
